import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_filer-portal/artifacts/r7yos9jv_logo-removebg-preview.png";

export function Logo({ className = "", withText = true, size = 40 }) {
  // "size" now scales the height of the wordmark logo (aspect ratio preserved).
  // withText is kept for API compatibility but the wordmark already includes text.
  return (
    <div className={`flex items-center ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Taxfree Filer LLP — U.S. Tax Filing Specialist for NRIs"
        style={{ height: withText ? size : Math.round(size * 0.9), width: "auto" }}
        className="select-none"
        draggable="false"
      />
    </div>
  );
}
